module.exports = __webpack_public_path__ + "1792395595471/fonts/Flaticon.122c478.eot";